// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"Modal_modal-content__4T8au","close-panel":"Modal_close-panel__aE38s","root":"Modal_root__LTe4d","modal":"Modal_modal__wiXHz","modal-body":"Modal_modal-body__lzv1N"};